export class UploadParams{
  /**
   * @param {UploadParams} opts
   */
  constructor(opts = {}){
    /**
     * @type {File} 要上傳的檔案
     */
    this.file = opts.file
    /**
     * @type {?String} 描述檔案的標題
     */
    this.title = opts.title || null
    /**
     * @type {?String} 檔案原始名稱
     */
    this.name = opts.name || null
    /**
     * @type {?Number} 檔案大小 (單位 byte)
     */
    this.size = opts.size
    /**
     * @type {?String} 副檔名
     */
    this.extension = opts.extension
    /**
     * @type {String} 類型 (video|image|audio)
     */
    this.type = opts.type
    /**
     * @type {String} 該檔案應該掛在的 Message 的 劇本ID
     */
    this.sid = opts.sid
    /**
     * @type {String} 該檔案應該掛在的 Message 的 場景ID
     */
    this.scene = opts.scene
    /**
     * @type {String} 該檔案應該掛在的 Message 的 ID
     */
    this.message_id = opts.message_id
  }
  toFormData(){
    let form = new FormData()
    for(let field of fields){
      form.append(field, this[field])
    }
    return form
  }
}
export const fields = ['file', 'title', 'name', 'size', 'extension', 'type', 'sid', 'scene', 'message_id']
export default UploadParams
